import { render, staticRenderFns } from "./r-receipt-form.vue?vue&type=template&id=388a4996&scoped=true"
import script from "./r-receipt-form.vue?vue&type=script&lang=js"
export * from "./r-receipt-form.vue?vue&type=script&lang=js"
import style0 from "./r-receipt-form.vue?vue&type=style&index=0&id=388a4996&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388a4996",
  null
  
)

export default component.exports